define( [
	"../../core"
], function( jQuery ) {
	return jQuery.now();
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/ajax/var/nonce.js
 ** module id = 887
 ** module chunks = 2
 **/